import { z } from 'zod';


const createAttendanceConceptBaseSchema = z.object({
  name: z.string().trim().min(1, 'attendance:attendanceConcept.validation.nameRequired'),
  code: z.string().trim().min(1, 'attendance:attendanceConcept.validation.codeRequired'),
  handlingId: z.union([
    z.coerce.number({ invalid_type_error: 'common:validation.invalidValue' }).int().positive(),
    z.null(),
  ]),
  calculationFormulaId: z.union([
    z.coerce.number({ invalid_type_error: 'common:validation.invalidValue' }).int().positive(),
    z.null(),
  ]),
  obtentionFormulaId: z.union([
    z.coerce.number({ invalid_type_error: 'common:validation.invalidValue' }).int().positive(),
    z.null(),
  ]),
});

export const createAttendanceConceptSchema = createAttendanceConceptBaseSchema
  .refine((data) => data.handlingId !== null, {
    message: 'attendance:attendanceConcept.validation.handlingRequired',
    path: ['handlingId'],
  })
  .refine((data) => data.calculationFormulaId !== null, {
    message: 'attendance:attendanceConcept.validation.calculationFormulaRequired',
    path: ['calculationFormulaId'],
  })
  .refine((data) => data.obtentionFormulaId !== null, {
    message: 'attendance:attendanceConcept.validation.obtentionFormulaRequired',
    path: ['obtentionFormulaId'],
  });

export type CreateAttendanceConceptFormData = z.infer<typeof createAttendanceConceptSchema>;
